import { render, staticRenderFns } from "./CheckOk.vue?vue&type=template&id=67d36026&"
import script from "./CheckOk.vue?vue&type=script&lang=js&"
export * from "./CheckOk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports